// extracted by mini-css-extract-plugin
export default {"section":"styles_section__bFBjs","position":"styles_position__GzcPO","position1":"styles_position1__7ux74"};